/* global google */

import Flicikity from 'flickity';
import { defer, createMap } from '../google-maps';
import { create as shortlist } from '../shortlist';
import { createNextArrow, createPrevArrow } from '../../base/carousel';

export function init() {
	const canvas = document.querySelector('.js-search-map');

	if (!canvas) {
		return;
	}

	// eslint-disable-next-line func-names
	defer(function() {
		let active;
		let bounds = new google.maps.LatLngBounds();

		const map = createMap(canvas, {
			center: { lat: 50.9433483, lng: -1.0169425 },
		});

		const cards = Array.from(document.querySelectorAll('.js-search-card'));

		cards.forEach(card => {
			propertyMarker(card, map);
			shortlist(card.querySelector('.js-search-card-shortlist'));
			let carouselElement = card.querySelector('.js-search-card-carousel');

			new Flicikity(carouselElement, {
				contain: true,
				draggable: false,
				lazyLoad: true,
				pageDots: true,
				wrapAround: true,
			});

			const nextButton = carouselElement.querySelector('.flickity-prev-next-button.next');
			const prevButton = carouselElement.querySelector('.flickity-prev-next-button.previous');

			nextButton.innerHTML = createNextArrow();
			prevButton.innerHTML = createPrevArrow();
		});

		map.fitBounds(bounds);
		map.addListener('click', closeActive);

		function closeActive() {
			if (!active) {
				return;
			}

			active.style.visibility = 'hidden';
			active = undefined;
		}

		function propertyMarker(card) {
			let lat = Number(card.dataset.lat);
			let lng = Number(card.dataset.lng);

			let marker = new google.maps.Marker({
				map: map,
				position: { lat, lng },
				icon: '/assets/icons/markers/property.svg',
			});

			bounds.extend({ lat, lng });

			marker.addListener('click', () => {
				closeActive();
				active = card;
				card.style.visibility = 'visible';
			});
		}
	});
}
